import React from 'react';
import '../CSS/About.scss'
import {motion} from 'framer-motion'
import {pageAnimation, } from '../Variants/variants'
import { skillsVariant, skillStagger, fade, aboutSlide } from '../Variants/aboutVariants'
import {faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {useScroll} from './useScroll'
import thumb from '../etc/thumbnail.jpg'

function About(){
    const [meRef, meControls] = useScroll()
    const [siteRef, siteControls] = useScroll()

    const skills = ["HTML", "CSS", "JavaScript", "React", "FramerMotion", "Sass", 
    "Styled Components", "EmberJS", "Java", "JavaFX", "C++", "Assembly", "PHP", "MySQL"]

    return(
        <motion.div className='about'
        variants={pageAnimation}
        initial="initial"
        animate="animate"
        exit="exit">
            <motion.div className='about-container'>
                <motion.div className='about-me-container' ref={meRef}>
                    <motion.div className='about-me' 
                    variants={fade}
                    initial="initial"
                    animate={meControls}>
                        <h1>About Me</h1>
                        <p>
                            I have a passion for coding and tend to be very creative. At first, I used to struggle
                            with <span>HTML</span> and <span>CSS</span> but now I'm able to recreate designs from just looking at it.
                            The main tech stack I use is <span>React</span> and <span>FramerMotion</span> for 
                            the animations. I also enjoy looking at other people's designs because it helps 
                            expand my creativity.
                        </p>
                        {/* <p>
                            Aside from coding, I also like drawing, <Link to="/drawings">as you can see</Link>, even though there's not a lot. 
                            I like browsing online for ideas, whether it's for art or design. And when I do find one, I would ask myself, 
                            "but can I recreate this?" and set it as a challenge.
                        </p> */}
                    </motion.div>
                    <motion.div className='about-skills-container'
                    variants={skillStagger}
                    initial="initial"
                    animate={meControls}
                    layout>
                        <motion.div 
                        className='about-skills'
                        layout
                        variants={skillsVariant}
                        initial="initial"
                        animate={meControls}
                        exit="exit"
                        >
                            <motion.div 
                            variants={skillStagger}
                            >
                                <motion.h2
                                variants={fade}
                                animate={meControls}
                                layout>{`<Skills/>`}</motion.h2>
                                <motion.ul>
                                    {skills.map((s, index) =>{
                                        return(
                                            <motion.li key={index}
                                            layout
                                            variants={fade}
                                            animate={meControls}>
                                                {s}
                                            </motion.li>
                                        )
                                    })}
                                </motion.ul>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                </motion.div>
                <motion.div className='about-site-container' ref={siteRef}>
                    <motion.div className='about-site'
                    custom={"-100%"}
                    variants={aboutSlide}
                    initial="initial"
                    animate={siteControls}>
                        <h1>About This Site</h1>
                        <p>
                        This site was created with <span>React</span> and <span>FramerMotion</span>. All the projects I've done helped me
                        solidify my knowledge in both of them and this is the final result to show for. 
                        I was also inspired by <a href='https://jacekjeznach.com/' target="_blank" rel="noreferrer">Jack Jeznach</a> with his text hover 
                        animations so much I had to recreate it. I broke it down and made a video talking about it here.
                        </p>
                    </motion.div>
                    <motion.div className='about-video'
                    custom={"100%"}
                    variants={aboutSlide}
                    initial="initial"
                    animate={siteControls}>
                        <div className='img'>
                            <a href='https://www.youtube.com/watch?v=ykR07FSEYcc' target="_blank" title="YouTube video" rel="noreferrer">
                                <img src={thumb} className="about-thumb"  alt="youtube thumbnail"/>
                                <p>
                                    <FontAwesomeIcon icon={faQuoteLeft}/>
                                    Recreating Jacek Jeznach's text hover effect
                                    <FontAwesomeIcon icon={faQuoteRight}/>
                                </p>
                            </a>
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>
        </motion.div>
    )
}

export default About;